export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10396.1080cf69.jpg";